function PeriodicalExecuter(callback, frequency) {
  this.callback = callback;
  this.frequency = frequency;
  this.currentlyExecuting = false;
  this.registerCallback();
  this.times = 0;
  return this;
}

PeriodicalExecuter.prototype = {
  registerCallback: function () {
    this.timer = setInterval(() => {
      this.onTimerEvent();
    }, this.frequency * 1000);
  },

  execute: function () {
    this.callback(this);
    this.times++;
  },

  stop: function () {
    if (!this.timer) return;
    clearInterval(this.timer);
    this.timer = null;
  },

  onTimerEvent: function () {
    if (!this.currentlyExecuting) {
      try {
        this.currentlyExecuting = true;
        this.execute();
      } finally {
        this.currentlyExecuting = false;
      }
    }
  },
};

export default PeriodicalExecuter;
